/**
 * Handle cookie banner display and acceptance
 */
export function initCookieBanner() {
  const banner = document.querySelector('.cookie-banner');
  const acceptButton = banner?.querySelector('.cookie-banner__accept');
  
  if (!banner || !acceptButton) return;
  
  // Check if user has already accepted cookies
  const hasAccepted = localStorage.getItem('cookiesAccepted');
  
  if (hasAccepted) {
    banner.style.display = 'none';
    return;
  }
  
  // Show banner if not accepted
  banner.style.display = 'block';
  
  // Handle accept button click
  acceptButton.addEventListener('click', () => {
    // Save acceptance in localStorage
    localStorage.setItem('cookiesAccepted', 'true');
    
    // Hide banner with animation
    banner.style.opacity = '0';
    setTimeout(() => {
      banner.style.display = 'none';
    }, 300);
  });
} 